import * as React from 'react';
import { IconDoubleCheck } from '../icons';
import type { DefaultFeedbackProps } from './BaseFeedback';
import { BaseFeedback } from './BaseFeedback';

export const PositiveFeedback: React.FC<React.PropsWithChildren<DefaultFeedbackProps>> = (props) => (
  <BaseFeedback textColor="tw-text-green-800" backgroundColor="tw-bg-green-50" {...props} icon={<IconDoubleCheck className="tw-mt-2 tw-pt-px" />} />
);
